import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { QuotaMovementsBatchService } from 'app/_services/quota-movements-batch.service';
import { QuotaMovementsBatch } from 'app/_models/quota-movements-batch';
import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { BatchLine } from 'app/_models/batch-line';
import { BatchLineService } from 'app/_services/batch-line.service';
import { NotificationsService } from 'app/_services/notifications.service';
import { environment } from 'environments/environment';
import { Form } from 'app/shared/form';
import { FormBuilder } from '@angular/forms';
import { QuotaTransferFormComponent } from '../components/quota-transfer-form/quota-transfer-form.component';
import { Quota } from 'app/_models/quota';

@Component({
  selector: 'app-quota-movements-batch',
  templateUrl: './quota-movements-batch.component.html',
  styleUrls: ['./quota-movements-batch.component.css'],
  providers: [QuotaMovementsBatchService, BatchLineService],
})
export class QuotaMovementsBatchComponent extends Form implements OnInit {
  @ViewChild('transferForm') transferForm: QuotaTransferFormComponent;

  public locale_es = environment.datepickerConfig;
  protected batch: QuotaMovementsBatch;
  public years = Quota.getYears();

  constructor(
    private fb: FormBuilder,
    protected route: ActivatedRoute,
    private quotaMovementsBatchService: QuotaMovementsBatchService,
    private batchLineService: BatchLineService,
    protected httpErrorHandler: HttpErrorHandler,
    private notificationsService: NotificationsService
  ) {
    super(route, httpErrorHandler);

    this.form = fb.group({
      date: '',
    });
  }

  public ngOnInit() {
    this.setFormMode('update');
    this.getMovementsBatch();
  }

  public onSubmit() {
    this.quotaMovementsBatchService.update(this.batch.serialize()).subscribe(
      (batch) => {},
      (error) => this.handleError(error)
    );
  }

  public getMovementsBatch() {
    this.route.params.forEach((params: Params) => {
      const id = +params['id'];
      this.quotaMovementsBatchService.get(id).subscribe(
        (batch) => {
          this.batch = new QuotaMovementsBatch().apiMap(batch);
        },
        (error) => this.httpErrorHandler.handleHttpError(error)
      );
    });
  }

  protected addLine(line: BatchLine) {
    this.getMovementsBatch();
  }

  protected deleteLine(line: BatchLine) {
    this.batchLineService.delete(line.id).subscribe(
      (empty) => {
        const index = this.batch.lines.indexOf(line, 0);
        this.batch.lines.splice(index, 1);
        this.notificationsService.notify('success', 'Eliminar línea', 'La línea se ha elimiado correctamente');
      },
      (error) => {
        this.notificationsService.notify('error', 'Eliminar línea', error.body[0]);
      }
    );
  }

  protected consolidated() {
    this.quotaMovementsBatchService.consolidate(this.batch.id).subscribe(
      (batch) => {
        this.batch = new QuotaMovementsBatch().apiMap(batch);
        this.notificationsService.notify('success', 'Consolidar comunicación', 'La comunicación se ha consolidado correctamente');
      },
      (error) => {
        this.notificationsService.notify('error', 'Consolidar comunicación', error.body[0]);
      }
    );
  }

  public exportToExcel() {
    this.quotaMovementsBatchService.exportToExcel().subscribe(
      (response) => {
        this.quotaMovementsBatchService.downloadExcel(response.token, this.batch.id);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  public changeYear(year: string): void {
    this.transferForm.setCurrentYear(year);
    this.transferForm.getQuotas();
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-batchs/quota-movements-batch/quota-movements-batch.component.ts